(function () {
    'use strict';

    var module = angular.module('uwAgenda.users');
    module.factory('UserWebsiteService', ['$http', 'SharedAgendaService', UserWebsiteService]);

    /* main user website service */
    function UserWebsiteService($http, SharedAgendaService) {

        var baseUrl = '/api/websites/';
        var service = {
            removeWebSite: removeWebSite,
            installWebSite: installWebSite,
            getWebsite: getWebsite,
            getByUser: getByUser,
            wp: wp
        };

        return service;

        /* wp */
        function wp(id, admin) {
            return $http({
                url: baseUrl + id + '/wp/agendas/' + SharedAgendaService.data.currentAgenda.id,
                method: 'GET',
                params: {
                    admin: admin !== undefined ? admin : null
                }
            }).then(function (response) {
                return response.data;
            });
        }

        /* remove website */
        function removeWebSite(id) {
            return $http.delete(baseUrl + id + '/agendas/' + SharedAgendaService.data.currentAgenda.id).then(function (response) {
                return response.data;
            });
        }

        /* install website */
        function installWebSite(website) {
            return $http.post(baseUrl + 'agendas/' + SharedAgendaService.data.currentAgenda.id, website).then(function (response) {
                return response.data;
            });
        }

        /* get website entity */
        function getWebsite(id) {
            return $http.get(baseUrl + id + '/agendas/' + SharedAgendaService.data.currentAgenda.id).then(function (response) {
                return response.data;
            });
        }

        /* get website by user */
        function getByUser(id) {
            return $http.get(baseUrl + 'users/' + id + '/agendas/' + SharedAgendaService.data.currentAgenda.id).then(function (response) {
                return response.data;
            });
        }
    }
})();